
import StyledCommonAlertComp from "./StyledCommonAlertComp"

const WarningAlert = ({ warningMsg }) => {
    return <StyledCommonAlertComp severity="info">{warningMsg || ""}</StyledCommonAlertComp>
}
export default WarningAlert